import React from 'react';
import Modal from 'jd-library/Modal';
import withPortal from 'jd-library/withPortal';
import styles from './transaction-type.scss';
import historyHandler from 'jd-library/historyHandler';

const TransactionModal = props => {
    const changeTransactionType = () => {
        historyHandler.closeCurrent();
        props.changeType();
    }
    let changeText = 'Transaction Type to Receive Enquiry';
    if(props.type != 'transaction') {
        changeText = 'Pricing Type to '+props.newType;
    }
    return (
            <Modal
                settings={{
                    modalId: 'transactiontype-modal',
                    variant: 'action',
                    class: ''
                }}
                onHidden={props.onHidden}
                backdropStatic={true}
            >
                <Modal.CloseIcon iconClass={'icon-HDRcross'} />
                <Modal.Header>{`Change ${changeText}`}</Modal.Header>
                <Modal.Body className={styles['body-container']}>
                    <div>
                        {`Changing ${changeText} will result in losing Multiple Variant data. Are you sure you want to change ${changeText}?`}
                    </div>
                </Modal.Body>
                <Modal.CenterButton className={styles['change-btn']} clickHandler={changeTransactionType}>
                    {`Change ${props.type == 'transaction' ? 'Transaction' : 'Pricing'} Type`}
                </Modal.CenterButton>
            </Modal>
    );
};

export default withPortal(TransactionModal);